import { render } from "./ContactItem.vue?vue&type=template&id=08706ec8&scoped=true"
import script from "./ContactItem.vue?vue&type=script&lang=js"
export * from "./ContactItem.vue?vue&type=script&lang=js"

import "./ContactItem.vue?vue&type=style&index=0&id=08706ec8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08706ec8"]])

export default __exports__